/* eslint-disable react/button-has-type */
import React, { useState } from 'react';
import './CvssCard.css';

const getSeverityInfo = (score, version) => {
  const s = parseFloat(score);
  if (version === '2.0') {
    if (s >= 7.0) return { text: 'HIGH', color: '#ff7d00' };
    if (s >= 4.0) return { text: 'MEDIUM', color: '#f39c12' };
    return { text: 'LOW', color: '#ffae00' };
  }
  // CVSS 3.0, 4.0
  if (s >= 9.0) return { text: 'CRITICAL', color: '#ff440c' };
  if (s >= 7.0) return { text: 'HIGH', color: '#ff7d00' };
  if (s >= 4.0) return { text: 'MEDIUM', color: '#f39c12' };
  if (s > 0) return { text: 'LOW', color: '#ffae00' };
  return { text: 'NONE', color: '#bdc3c7' };
};

function CvssCard({ version, data, translate }) {
  const [isExpanded, setIsExpanded] = useState(false);

  const info = {
    '4.0': {
      score: data.cvssv4.baseScore,
      vector: data.cvssv4.vectorString,
      severity: data.cvssv4.baseSeverity,
      details: [
        { label: 'Attack Vector', value: data.cvssv4.attackVector },
        { label: 'Attack Complexity', value: data.cvssv4.attackComplexity },
        { label: 'Attack Requirements', value: data.cvssv4.attackRequirements },
        { label: 'Privileges Required', value: data.cvssv4.privilegesRequired },
        { label: 'User Interaction', value: data.cvssv4.userInteraction },
        { label: 'Vuln Confidentiality', value: data.cvssv4.vulnConfidentialityImpact },
        { label: 'Vuln Integrity', value: data.cvssv4.vulnIntegrityImpact },
        { label: 'Vuln Availability', value: data.cvssv4.vulnAvailabilityImpact },
        { label: 'Sub Confidentiality', value: data.cvssv4.subConfidentialityImpact },
        { label: 'Sub Integrity', value: data.cvssv4.subIntegrityImpact },
        { label: 'Sub Availability', value: data.cvssv4.subAvailabilityImpact },
      ],
      threatDetails: [
        { label: 'Exploit Maturity', value: data.cvssv4.exploitMaturity },
      ],
      supplementalDetails: [
        { label: 'Safety', value: data.cvssv4.Safety },
        { label: 'Automatable', value: data.cvssv4.Automatable },
        { label: 'Recovery', value: data.cvssv4.Recovery },
        { label: 'Value Density', value: data.cvssv4.valueDensity },
        { label: 'Provider Urgency', value: data.cvssv4.providerUrgency },
        { label: 'Response Effort', value: data.cvssv4.vulnerabilityResponseEffort },
      ]
    },
    '3.0': {
      score: data.scorev3,
      vector: data.vectorv3,
      severity: data.base_severity_v3,
      details: [
        { label: 'Attack Vector', value: data.attack_vector_v3 },
        { label: 'Attack Complexity', value: data.attack_complexity_v3 },
        { label: 'Privileges Required', value: data.privileges_required_v3 },
        { label: 'User Interaction', value: data.user_interaction_v3 },
        { label: 'Scope', value: data.scope_v3 },
        { label: 'Confidentiality', value: data.confidentiality_impact_v3 },
        { label: 'Integrity', value: data.integrity_impact_v3 },
        { label: 'Availability', value: data.availability_impact_v3 },
      ],
      threatDetails: [],
      supplementalDetails: [],
    },
    '2.0': {
      score: data.scorev2,
      vector: data.vectorv2,
      severity: null,
      details: [
        { label: 'Access Vector', value: data.access_vector },
        { label: 'Access Complexity', value: data.accesscomplexity },
        { label: 'Authentication', value: data.authentication },
        { label: 'Confidentiality', value: data.confidentialityimpact },
        { label: 'Integrity', value: data.integrityimpact },
        { label: 'Availability', value: data.availabilityimpact },
      ],
      threatDetails: [],
      supplementalDetails: [],
    },
  }[version];

  const renderDetailSection = (title, details) => {
    const validDetails = details.filter((d) => { return d.value && d.value !== 'NOT_DEFINED'; });
    if (validDetails.length === 0) return null;

    return (
      <>
        <h4 className="cvss-section-title">{title}</h4>
        {validDetails.map((detail) => {
          return (
            <div key={detail.label} className="cvss-detail-item">
              <div className="cvss-detail-label">{detail.label}</div>
              <div className="cvss-detail-value">{detail.value}</div>
            </div>
          );
        })}
      </>
    );
  };

  const severity = info.severity
    ? { text: info.severity.toUpperCase(), color: getSeverityInfo(info.score, version).color }
    : getSeverityInfo(info.score, version);

  return (
    <div className="cvss-card">
      <div className="cvss-header">
        <h3 className="cvss-title">
          CVSS v
          {version}
        </h3>
      </div>
      <div className="cvss-main-content">
        <div className="cvss-score">{info.score}</div>
        <div
          className="cvss-severity-badge"
          style={{ backgroundColor: severity.color }}
        >
          {severity.text}
        </div>
      </div>
      <div className="cvss-vector">{info.vector}</div>
      <div className="cvss-actions">
        <button onClick={() => { return setIsExpanded(!isExpanded); }} className="cvss-button">
          {isExpanded ? translate('modal.cve.hide_details') : translate('modal.cve.view_details')}
        </button>
      </div>
      {isExpanded && (
        <div className="cvss-details-container">
          {renderDetailSection('Base Metrics', info.details)}
          {renderDetailSection('Threat Metrics', info.threatDetails)}
          {renderDetailSection('Supplemental Metrics', info.supplementalDetails)}
        </div>
      )}
    </div>
  );
}

export default CvssCard;
